<template>
  <CModal
    size="lg"
    :centered="false"
    :closeOnBackdrop="false"
    :show.sync="isAddQueueShow"
    class="CmodalCustom"
  >
    <CCol xl="5" lg="5" md="12" sm="12" class="container DivInfotranparent">
      <CCard class="CardInfotranparent">
        <CCol>
          <CRow align-vertical="center" align-horizontal="center">
            <h1 :class="checkLangClass()">
              {{ checkLanguage(cardContent.title) }}
            </h1>
          </CRow>
          <CRow alignHorizontal="center" alignVertical="center">
            <VocabAudio
              :cardContent="cardContent"
              :cardType="cardType"
              :soundObject="soundObj"
            />
          </CRow>
          <CCol class="justifycontent">
            <hr class="LineBorder" />
          </CCol>
          <CRow align-vertical="center" align-horizontal="center" class="mb-3">
            <h2 :class="checkLangClass()">
              {{ checkLanguage(cardContent.desciption) }}
            </h2>
          </CRow>
          <CCol>
            <CRow align-vertical="center" align-horizontal="center">
              <CButton
                @click="linkTo(cardContentPaht.navigate.next.action)"
                color="success"
                shape="pill"
                size="lg"
                class="ml-2 mr-2 mt-5"
                >NEXT</CButton
              >
            </CRow>
          </CCol>
        </CCol>
      </CCard>
    </CCol>
  </CModal>
</template>

<script>
import TextComponent from "./TextComponent";
import VocabAudio from "./VocabAudio";
import { mapGetters } from "vuex";
export default {
  components: {
    TextComponent,
    VocabAudio,
  },
  name: "CardPopupInfoTranparent",
  props: {
    isAddQueueShow: Boolean,
    setAddQueueVisible: Function,
    cardType: String,
    CardPopupImg: Object,
    cardContent: Object,
    openModal: Function,
    cardContentPaht: Object,
    updateUser: Function,
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_URL_SOUND,
      lang: "",
      soundObj: {},
    };
  },
  computed: {
    ...mapGetters({
      getLanguage: "language/getLanguage",
    }),
  },
  watch: {
    getLanguage: function(val) {
      this.lang = val;
    },
    cardContent: function() {
      this.soundObj = new Audio(this.baseUrl + this.cardContent.item[1].data);
    },
  },
  mounted() {},
  created() {
    this.lang = this.$store.state.language.language;
    this.soundObj = new Audio(this.baseUrl + this.cardContent.item[1].data);
  },
  beforeDestroy() {},
  methods: {
    checkLangClass() {
      if (this.lang == "CN") {
        return "fontChinese";
      } else if (this.lang == "PIN IN") {
        return "fontPinin";
      } else {
        return "";
      }
    },
    linkTo(path) {
      let str = path.split("-");
      this.$emit("updateUser");
      this.$router.push("/" + str[0] + "/" + str[1]);
    },
    findPinIn(val) {
      if (val) {
        for (let i = 0; i <= val.length; i++) {
          if (val[i].key == "PIN IN") {
            return val[i].value;
          }
        }
      }
    },
    checkLanguage(val) {
      if (val) {
        for (let i = 0; i <= val.length; i++) {
          if (val[i].key == this.lang) {
            return val[i].value;
          }
        }
      } else {
      }
    },
  },
};
</script>

<style scoped>
.HeadContent {
  padding-bottom: 50px;
}
.justifycontent {
  display: flex;
  justify-content: center;
}
.LineBorder {
  width: 50%;
  border: 1px solid;
  height: 0rem;
}
.DivInfotranparent {
  display: flex;
}
.CardInfotranparent {
  display: flex;
  justify-content: center;
  background-color: transparent;
  width: 100%;
  border: none;
  color: white;
}
.card-header {
  border-bottom: 0px !important;
}
.TopicHead {
  text-align: center;
  font-size: 50px;
  padding-top: 50px;
}
.Topic {
  text-align: center;
  font-size: 30px;
}
.overflow-auto {
  backdrop-filter: blur(10px);
}
/* .BTNNextText {
  color: white;
  background-color: #349e54;
  width: 250px;
  height: 100px;
  font-size: 30px;
}
.ButtonNextPrev {
  justify-content: center;
  padding-top: 100px;
  padding-bottom: 50px; */
/* } */
</style>
